export const set = (key: string, value) => localStorage.setItem(key, value)

export const get = (key: string) => localStorage.getItem(key)

export const remove = (key: string) => localStorage.removeItem(key)
